import '.as{position:fixed;}.ssr-plugin'
import '.cz{top:0;}.ssr-plugin'
import '.c5{left:0px;}.ssr-plugin'
import '.c6{right:0px;}.ssr-plugin'
import '.fi{bottom:0px;}.ssr-plugin'
import '.gz{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.h0{z-index:998;}.ssr-plugin'
import '.h1{transition:opacity 0.3s ease;}.ssr-plugin'
import '.am{height:100vh;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.b5{background-color:var(--palette-white);}.ssr-plugin'
import '.h2{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h3{z-index:999;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.aw{justify-content:space-between;}.ssr-plugin'
import '.cn{padding:1.5rem;}.ssr-plugin'
import '.h4{border-bottom:var(--border-default);}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.ch{flex:1;}.ssr-plugin'
import '.ba{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="as cz c5 c6 fi gz h0 h1"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="as cz am h b5 h2 h3 l m"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="l aa aw cn h4 e"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="ch ba cn"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
